// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Support'"></sub-header>

  <div class="form-section">
    <span class="label">Please select a support case:</span>
    <select ng-model="\$ctrl.supportCase"
            ng-options="entry.code as entry.description for entry in \$ctrl.supportCases"
            ng-change="\$ctrl.changeSupportCase()"></select>
  </div>

  <div class="support-pane">
    <div id="support"></div>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/support-case-picker/support-case-picker.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;